import axiosApi from "api/root.api";

/**
 * 本期方案用量（計費用，來源為 DB 計數），不是物件卡片／報表頁上的 GA 閱覽數。
 * 畫面文案請用「方案用量」，勿寫成「閱覽數」以免與 GA 數字混淆。
 */
export const visitGet = async () => {
  const urlEnd = "/publish/v1/product/visit/currentMonth";
  const response = await axiosApi.get(urlEnd);
  const result = response.data;
  return result;
};
